import { ProcessType } from '../../../../../Services/WorkflowServicesTypes';

const relatedProcesses = [
	{
		processType: ProcessType.ProductFeed, related: [
			ProcessType.ProductFeedPreprocessing
		]
	},
	{
		processType: ProcessType.ProductFeedPreprocessing, related: [
			ProcessType.ProductFeed
		]
	},
	{
		processType: ProcessType.ProductRanking, related: [
			ProcessType.ProductFeed, ProcessType.ProductFeedPreprocessing
		]
	},
	{
		processType: ProcessType.Compositions, related: [
			ProcessType.ProductFeed, ProcessType.ProductFeedPreprocessing
		]
	},
	{
		processType: ProcessType.PersonalisedCompositions, related: [
			ProcessType.ProductFeed, ProcessType.ProductFeedPreprocessing
		]
	},
	{
		processType: ProcessType.ProductCatalog, related: [
			ProcessType.ProductFeed, ProcessType.ProductFeedPreprocessing
		]
	},
	{
		processType: ProcessType.ProductRecommendations, related: [
			ProcessType.ProductFeed, ProcessType.ProductFeedPreprocessing
		]
	},
];

export default relatedProcesses;